export default __webpack_public_path__ + "static/media/Sandals of the Shivering Stars.1468fd49.jpg";